import React from "react";
import { Code2, X, ChevronRight, User, UserPlus } from "lucide-react";

export const getWorkspaceNameForChild = (child) => {
  if (child?.workspace === "scratch_jr") return "Practido Junior Blocks";
  if (child?.workspace === "scratch") return "Practido Blocks";
  if (child?.workspace === "python") return "Practido Code";

  const gradeStr = (child?.grade || "").toString();
  const numMatch = gradeStr.match(/\d+/);
  const gradeNum = numMatch ? parseInt(numMatch[0], 10) : 5;

  if (gradeNum >= 1 && gradeNum <= 3) {
    return "Practido Junior Blocks";
  } else if (gradeNum >= 4 && gradeNum <= 8) {
    return "Practido Blocks";
  } else if (gradeNum >= 9) {
    return "Practido Code";
  }
  return "Practido Blocks";
};

const ChildSelectModal = ({
  isOpen,
  onClose,
  childrenList = [],
  onSelectChild,
  onAddChild,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl p-6 sm:p-8 max-w-md w-full shadow-2xl space-y-6 animate-in zoom-in-95 duration-200 border border-slate-100 font-sans text-slate-800">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-2xl bg-purple-100 text-purple-700 flex items-center justify-center font-bold">
              <Code2 className="w-5 h-5" />
            </div>
            <div>
              <h3 className="text-lg font-black text-slate-900">Select Student</h3>
              <p className="text-xs text-slate-500 font-medium">
                Choose a child to launch their workspace
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 flex items-center justify-center transition-colors cursor-pointer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {childrenList && childrenList.length > 0 ? (
          <div className="space-y-3 max-h-72 overflow-y-auto pr-1">
            {childrenList.map((child) => {
              const workspaceName = getWorkspaceNameForChild(child);
              return (
                <button
                  key={child.id || child.uid}
                  type="button"
                  onClick={() => onSelectChild(child)}
                  className="w-full p-4 rounded-2xl border border-slate-200 hover:border-purple-500 hover:bg-purple-50/50 flex items-center justify-between text-left transition-all duration-200 group cursor-pointer"
                >
                  <div className="space-y-1">
                    <h4 className="font-extrabold text-slate-800 text-sm group-hover:text-purple-700">
                      {child.name}
                    </h4>
                    <p className="text-xs text-slate-500 font-medium">
                      {child.grade
                        ? child.grade.toLowerCase().startsWith("class")
                          ? child.grade
                          : `Class ${child.grade}`
                        : "Class N/A"}{" "}
                      •{" "}
                      <span className="font-bold text-purple-600">
                        {workspaceName}
                      </span>
                    </p>
                  </div>
                  <div className="w-8 h-8 rounded-xl bg-purple-100 text-purple-700 group-hover:bg-purple-600 group-hover:text-white flex items-center justify-center transition-colors flex-shrink-0">
                    <ChevronRight className="w-4 h-4" />
                  </div>
                </button>
              );
            })}
          </div>
        ) : (
          <div className="p-5 text-center bg-slate-50 border border-slate-200/80 rounded-2xl space-y-2">
            <User className="w-8 h-8 text-purple-400 mx-auto" />
            <h4 className="text-sm font-black text-slate-800">No Children Added Yet</h4>
            <p className="text-xs text-slate-500 font-medium">
              Add your child to unlock Practido Code Studio tailored specifically to their learning path!
            </p>
          </div>
        )}

        <div className="pt-2 border-t border-slate-100">
          <button
            type="button"
            onClick={onAddChild}
            className="w-full py-3 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-extrabold text-xs rounded-2xl shadow-md shadow-purple-500/20 flex items-center justify-center gap-2 transition cursor-pointer"
          >
            <UserPlus className="w-4 h-4" />
            <span>Add Child</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChildSelectModal;
